import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { i18n } from "./i18n";
import { runtimeConfig, validateRuntimeConfig } from "./runtime-config";
import { router } from "./router";
import { applyRouteSeo } from "./seo";
import "./styles/main.scss";

const runtimeValidation = validateRuntimeConfig(runtimeConfig);
applyDocumentMetadata();

if (!runtimeValidation.ok) {
  renderRuntimeConfigError(runtimeValidation.errors);
} else {
  const app = createApp(App);

  app.use(createPinia());
  app.use(i18n);
  app.use(router);
  app.mount("#app");
}

function applyDocumentMetadata() {
  document.documentElement.lang = runtimeConfig.market.isChinaVersion ? "zh-CN" : "en";
  applyRouteSeo({ path: window.location.pathname });
}

function renderRuntimeConfigError(errors: string[]) {
  const root = document.querySelector("#app");
  if (!root) {
    return;
  }
  const copy = runtimeConfig.market.isChinaVersion
    ? {
        eyebrow: "启动配置需要确认",
        title: "前端还没有连到正式后端",
        body: "为了避免用户进入不可用流程，生产环境会拦截本机 API 配置。请调整环境变量后重新发布。"
      }
    : {
        eyebrow: "Runtime configuration needed",
        title: "The frontend is not connected to the production API",
        body: "To keep users out of an unavailable flow, production blocks local API settings. Update the environment variables and publish again."
      };

  root.innerHTML = `
    <main class="runtime-config-error">
      <section class="runtime-config-error__panel">
        <p class="runtime-config-error__eyebrow">${escapeHtml(copy.eyebrow)}</p>
        <h1>${escapeHtml(copy.title)}</h1>
        <p class="runtime-config-error__body">
          ${escapeHtml(copy.body)}
        </p>
        <ul>
          ${errors.map((error) => `<li>${escapeHtml(error)}</li>`).join("")}
        </ul>
      </section>
    </main>
  `;
}

function escapeHtml(value: string) {
  const replacements: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
  };
  return value.replace(/[&<>"']/g, (char) => replacements[char]);
}
